import React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

export const Loading = ({ texto = "Cargando..." }) => {
  return (
    <Backdrop open={true} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          color="primary"
          sx={{
            marginBottom: 3,
          }}
        />
        <Typography color="white">{texto}</Typography>
      </Box>
    </Backdrop>
  );
};
